function emailValidator(value = '') {
  let isValid

  const { path, createError } = this

  if (value.length === 0) {
    return true
  }

  isValid = value.match(
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+([a-zA-Z0-9]{2,})$/,
  )

  return (
    isValid ||
    createError({
      path,
      message: 'common::validation_messages.incorrect_email_format',
    })
  )
}

export default emailValidator
